<template>
  <common
    :searchFrom="searchFrom"
    :tableTitle="tableTitle"
    :list="list"
    @crudClick="crudClick"
    :total="total"
    :arrPageSize="arrPageSize"
    :pageSize="searchFrom.pageSize"
    :BoolModal="isshowModal"
    :title="titleModal"
    @changeBindModal="changeBindModal"
    @closedeleteModal="closedeleteModal"
    :unChange="unChange"
    :footerHide="footerHide"
    :width="width"
    :loading="loading"
    :maskClosable="maskClosable"
    :current.sync="current"
    @pageClick="getList"
    ref="common"
  >
    <template slot="add">
      <FormItem>
        <Button type="primary" @click="crudClick(0, 'add')" icon="md-add">
          {{ $t("add") }}
        </Button>
      </FormItem>
    </template>

    <div slot="content">
      <template v-if="crudText == 'delete'">
        <p>{{ $t("titleModal") }}</p>
      </template>
      <template v-else>
        <Form
          label-position="right"
          :model="dataDetails"
          :label-width="130"
          :rules="ruleFrom"
          ref="dataDetails"
        >
          <FormItem :label="$t('roleName')" prop="title">
            <i-Input
              :disabled="disabled"
              v-model="dataDetails.title"
              placeholder="Please Enter Name"
            ></i-Input>
          </FormItem>
          <FormItem :label="$t('type')" prop="mapping">
            <Select
              v-model="dataDetails.mapping"
              filterable
              :disabled="disabled"
              placeholder="Please Select Type"
            >
              <Option
                v-for="item in mappingList"
                :value="item.val"
                :key="item.val"
                >{{ item[$i18n.locale] }}</Option
              >
            </Select>
          </FormItem>
        </Form>
      </template>
    </div>
  </common>
</template>

<script>
import { getRole, add, getDetails, update, del } from "@/api/system/role";
import common from "_c/common-body";
import boxMes from "@/utils/message";
import format from "@/utils/format";

export default {
  name: "role",
  components: {
    common,
  },
  data() {
    return {
      current: 1,
      arrPageSize: [15, 30, 50, 100],
      maskClosable: false,
      loading: true,
      width: 600,
      list: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: "",
      },
      // Warehouse总数据
      total: 0,
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {},
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      disabled: false,
      ruleFrom: {
        title: [
          {
            required: true,
            message: "name cannot be empty",
            trigger: "blur",
          },
        ],
        mapping: [
          {
            required: true,
            message: "Please select Type",
            trigger: "change",
          },
        ],
      },
      footerHide: false,
      crudText: "",
      titleModal: "",
      countryList: [],
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true,
      mappingList: [
        {
          "zh-CN": "超级管理员",
          "en-US": "Administrator",
          val: "Administrator",
        },
        {
          "zh-CN": "管理员",
          "en-US": "WarehouseManager",
          val: "WarehouseManager",
        },
        {
          "zh-CN": "客户服务",
          "en-US": "CustomerService",
          val: "CustomerService",
        },
        { "zh-CN": "会计服务", "en-US": "Accounting", val: "Accounting" },
        { "zh-CN": "销售员", "en-US": "Salesman", val: "Salesman" },
        { "zh-CN": "派送员", "en-US": "Driver", val: "Driver" },
        { "zh-CN": "客户", "en-US": "Client", val: "Client" },
        { "zh-CN": "代理", "en-US": "Agent", val: "Agent" },
      ],
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("roleName"),
        key: "title",
        align: "center",
      });
      columns.push({
        title: this.$t("type"),
        key: "mapping",
        align: "center",
      });
      columns.push({
        title: this.$t("createTime"),
        key: "create_time",
        align: "center",
        minWidth: 160,
      });
      columns.push({
        title: this.$t("upTime"),
        key: "update_time",
        align: "center",
        minWidth: 160,
      });
      columns.push({
        title: this.$t("operation"),
        slot: "operation",
        align: "center",
        width: 200,
      });
      return columns;
    },
  },
  watch: {
    dataDetails: {
      handler: function (nowVal) {
        var $this = this;
        for (let i in $this.dataDetails) {
          if (nowVal[i] !== $this.preForm[i]) {
            $this.unChange = false;
            break;
          } else {
            $this.unChange = true;
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getList(this.searchFrom);
  },
  methods: {
    changeBindModal(val) {
      if (!val) {
        this.closedeleteModal(false);
      } else {
        if (this.crudText === "delete") {
          console.log(this.delId);
          this.deleteList(this.delId);
        } else {
          this.confirm("dataDetails");
        }
      }
    },
    closedeleteModal(e) {
      if (e === false) {
        this.isshowModal = false;
        if (this.crudText != "delete") {
          this.$refs["dataDetails"].resetFields();
        }
      }
    },
    confirm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.crudText === "add") {
            this.addList();
          } else {
            this.updateList();
          }
        } else {
          console.log(this.$t("fail"));
        }
      });
    },
    crudClick(item, text) {
      this.titleModal = this.$t(text);
      this.maskClosable = false;
      this.width = 600;
      this.footerHide = false;
      this.unChange = true;
      this.disabled = false;
      this.dataDetails = {};
      this.preForm = {};
      if (item !== 0) {
        if (text == "delete") {
          this.width = 300;
          this.delId = item.id;
          this.unChange = false;
          this.maskClosable = true;
        } else {
          if (text === "show") {
            this.disabled = true;
            this.footerHide = true;
            this.maskClosable = true;
          }
          this.getDetailsList(item.id, text);
        }
      }
      this.isshowModal = true;
      this.crudText = text;
    },
    getDetailsList(id) {
      getDetails(id)
        .then((res) => {
          this.dataDetails = res.data.payload;
          this.preForm = JSON.parse(JSON.stringify(res.data.payload));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getList(data) {
      this.loading = true;
      getRole(data).then((res) => {if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
        this.list = res.data.payload.rows.map((item) => {
          item.create_time = format.timeFormat(item.create_time * 1000);
          item.update_time = format.timeFormat(item.update_time * 1000);
          return item;
        });
        this.total = res.data.payload.total;
        this.loading = false;
      });
    },
    addList() {
      add(this.dataDetails).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
    updateList() {
      delete this.dataDetails.country;
      update(this.dataDetails).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
    deleteList(id) {
      del(id).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
  },
};
</script>

<style scoped lang="less">
</style>
